var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress === 'input')?_c('change-component'):(_vm.progress === 'result')?_c('result-component'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }